import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/private/pagination";

const Offers = () => {
  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtro por texto
  const [filter, setFilter] = useState({
    searchQuery: "",
    searchBy: "program",
  });

  // Filtro por estado (Nuevo)
  const [stateFilter, setStateFilter] = useState("");

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Modal Estado
  const [showModal, setShowModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);

  // Modal Detalle
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailOffer, setDetailOffer] = useState(null);

  useEffect(() => {
    if (!token) return;

    const loadOffers = async () => {
      setLoading(true);
      const data = await authFetch(ENDPOINTS.getOffers);

      if (data.success) setOffers(data.offers);
      else setOffers([]);

      setLoading(false);
    };

    loadOffers();
  }, [token, authFetch]);

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
    setCurrentPage(1);
  };

  // ---------- FILTRO PRINCIPAL + FILTRO ESTADO ----------
  const handleSearch = () => {
    const query = filter.searchQuery.toLowerCase();

    return offers.filter((offer) => {
      let matchesText = false;

      switch (filter.searchBy) {
        case "program":
          matchesText = offer.professional_program.toLowerCase().includes(query);
          break;
        case "area":
          matchesText = offer.area_name.toLowerCase().includes(query);
          break;
        case "place":
          matchesText = offer.place.toLowerCase().includes(query);
          break;
        case "contract":
          matchesText = offer.type_contract.toLowerCase().includes(query);
          break;
        default:
          matchesText = true;
      }

      // Nuevo: filtro por estado
      const matchesState =
        stateFilter === "" || offer.state.toString() === stateFilter;

      return matchesText && matchesState;
    });
  };

  const filteredOffers = handleSearch();
  const totalPages = Math.ceil(filteredOffers.length / recordsPerPage);
  const currentOffers = filteredOffers.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // Modal cambiar estado
  const openModal = (offer) => {
    setSelectedOffer(offer);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedOffer(null);
    setShowModal(false);
  };

  const handleConfirmToggle = async () => {
    if (!selectedOffer) return;

    try {
      const newState = selectedOffer.state == 1 ? 0 : 1;

      const res = await authFetch(
        `${ENDPOINTS.changeStateOffer}?id=${selectedOffer.IdOfertas}`,
        {
          method: "PUT",
          body: JSON.stringify({ state: newState }),
        }
      );

      if (res.success) {
        alert("Estado actualizado.");

        setOffers((prev) =>
          prev.map((o) =>
            o.IdOfertas === selectedOffer.IdOfertas ? { ...o, state: newState } : o
          )
        );
      } else {
        alert("Error al actualizar estado.");
      }
    } catch (error) {
      alert("Error con el servidor.");
    }

    closeModal();
  };

  // Modal Detalle
  const openDetailModal = (offer) => {
    setDetailOffer(offer);
    setShowDetailModal(true);
  };

  const closeDetailModal = () => {
    setDetailOffer(null);
    setShowDetailModal(false);
  };

  if (loading) return <p>Cargando ofertas...</p>;

  return (
    <div className="container mt-4 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Lista de Ofertas Laborales</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/offer/createOffer")}
        >
          <i className="bi bi-briefcase-fill me-1"></i> Crear Oferta
        </button>
      </div>

      {/* BUSCADOR */}
      <div className="row mb-3">

        {/* BUSCADOR TEXTO */}
        <div className="col-md-5">
          <label className="m-1">Buscar por programa, área, lugar o contrato</label>
          <input
            type="text"
            name="searchQuery"
            className="form-control"
            value={filter.searchQuery}
            onChange={handleFilterChange}
          />
        </div>

        {/* SELECT TIPO DE BÚSQUEDA */}
        <div className="col-md-4">
          <label className="m-1">Tipo de búsqueda:</label>
          <select
            className="form-select"
            name="searchBy"
            value={filter.searchBy}
            onChange={handleFilterChange}
          >
            <option value="program">Por Programa</option>
            <option value="area">Por Área</option>
            <option value="place">Por Lugar</option>
            <option value="contract">Por Contrato</option>
          </select>
        </div>

        {/* NUEVO SELECT POR ESTADO */}
        <div className="col-md-3">
          <label className="m-1">Filtrar por estado:</label>
          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => setStateFilter(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="1">Activas</option>
            <option value="0">Inactivas</option>
          </select>
        </div>
      </div>

      {currentOffers.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Programa</th>
                <th>Área</th>
                <th>Contrato</th>
                <th>Duración</th>
                <th>Lugar</th>
                <th>Salario</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentOffers.map((offer) => (
                <tr key={offer.IdOfertas} style={{ cursor: "pointer" }}>
                  <td>{offer.professional_program}</td>
                  <td>{offer.area_name}</td>
                  <td>{offer.type_contract}</td>
                  <td>{offer.duration}</td>
                  <td>{offer.place}</td>
                  <td>
                    {offer.salary && offer.salary !== ""
                      ? Number(offer.salary).toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                          minimumFractionDigits: 0,
                        })
                      : "A convenir"}
                  </td>
                  <td>{offer.state == 1 ? "Activa" : "Inactiva"}</td>

                  <td>
                    <div className="d-flex gap-2">
                      {/* DETALLES */}
                      <button
                        className="btn btn-light btn-sm d-inline-flex align-items-center me-1"
                        onClick={() => openDetailModal(offer)}
                      >
                        <i className="bi bi-eye me-1"></i>
                      </button>
                      {/* MODIFICAR */}
                      {offer.state == 1 && (
                        <button
                          className="btn btn-secondary btn-sm d-inline-flex align-items-center me-1"
                          onClick={() =>
                            navigate(`/session/offer/updateOffer/${offer.IdOfertas}`)}>
                          <i className="bi bi-pencil-square me-1"></i>
                          <span>Modificar</span>
                        </button>
                      )}

                      {/* ACTIVAR / DESACTIVAR */}
                      <button
                        className={`btn btn-sm d-inline-flex align-items-center ${
                          offer.state == 1
                            ? "btn-outline-pink"
                            : "btn-outline-purple"
                        }`}
                        onClick={() => openModal(offer)}
                      >
                        <i className="bi bi-power me-1"></i>
                        <span>{offer.state == 1 ? "Desactivar" : "Activar"}</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINACIÓN */}
         <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>
      ) : (
        <p>No hay ofertas registradas.</p>
      )}

      {/* -------- MODAL DETALLES -------- */}
      {showDetailModal && detailOffer && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={closeDetailModal}
            style={{ cursor: "pointer" }}
          ></div>

          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="modal-title text-left ">
                    {detailOffer.professional_program}
                  </h3>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeDetailModal}
                  ></button>
                </div>

                <div className="modal-body">
                  <p>
                    <b>Área:</b> {detailOffer.area_name}
                  </p>

                  <div className="row">
                    <div className="col-6">
                      <p>
                        <i className="bi bi-journal"></i>{" "}
                        <b>Contrato:</b> {detailOffer.type_contract}
                      </p>
                    </div>
                    <div className="col-6">
                      <p>
                        <i className="bi bi-clock"></i>{" "}
                        <b>Duración:</b> {detailOffer.duration}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <p>
                        <i className="bi bi-geo-alt"></i>{" "}
                        <b>Lugar:</b> {detailOffer.place}
                      </p>
                    </div>
                    <div className="col-6">
                      <p>
                        <i className="bi bi-cash-stack"></i>{" "}
                        <b>Salario:</b>{" "}
                        {Number(detailOffer.salary).toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                          minimumFractionDigits: 0,
                        })}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <p>
                        <i className="bi bi-bookmark"></i>{" "}
                        <b>Educación mínima:</b>{" "}
                        {detailOffer.minimum_education}
                      </p>
                    </div>
                    <div className="col-6">
                      <p>
                        <i className="bi bi-person-workspace"></i>{" "}
                        <b>Experiencia:</b> {detailOffer.experience}
                      </p>
                    </div>
                  </div>

                  <p>
                    <b>Funciones:</b> {detailOffer.functions}
                  </p>

                  {detailOffer.curso_altura === "Si" && (
                    <p>
                      <b>Curso de altura:</b> Sí
                    </p>
                  )}
                  {detailOffer.curso_manipulacion_alimento === "Si" && (
                    <p>
                      <b>Curso de manipulación de alimentos:</b> Sí
                    </p>
                  )}
                  {detailOffer.professional_card === "Si" && (
                    <p>
                      <b>Tarjeta profesional:</b> Sí
                    </p>
                  )}
                </div>

                <div className="modal-footer d-flex justify-content-between">
                  <small className="m-0">
                    <b>Fecha de publicación:</b>{" "}
                    {new Date(
                      detailOffer.created_at
                    ).toLocaleDateString("es-CO")}
                  </small>

                  <button
                    className="btn btn-outline-pink"
                    onClick={closeDetailModal}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* -------- MODAL CAMBIAR ESTADO -------- */}
      {showModal && (
        <>
          <div
            className="modal-backdrop fade show"
            onClick={closeModal}
            style={{ cursor: "pointer" }}
          ></div>

          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Cambiar Estado</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>

                <div className="modal-body">
                  <p>
                    ¿Deseas cambiar el estado de la oferta{" "}
                    <b>{selectedOffer?.professional_program}</b>?
                  </p>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button
                    className="btn btn-outline-pink"
                    onClick={handleConfirmToggle}
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Offers;
